import React from "react";
import {OrbitComponent} from "../../../base-components/orbit-component/orbit-component";
import {CyClass} from "../../../../../common/cy-classes";
import {Image} from "../../../raw-components/image/image";
import {TippingHistoryRecordStartSectionBox} from "./boxes/start-section/tipping-history-record-start-section.box";
import {observer} from "mobx-react";
import {ITippingHistoryRecordViewModel} from "../../../../services/tipping-history/models/tipping-history-view-model.interface";

interface TippingHistoryRecordStartSectionComponentProps {
    record: ITippingHistoryRecordViewModel;
}

export const TippingHistoryRecordContentStartSectionComponent = observer(
    class TippingHistoryRecordContentStartSectionComponent extends OrbitComponent<TippingHistoryRecordStartSectionComponentProps> {
        render() {
            return (
                <TippingHistoryRecordStartSectionBox>
                    <Image src={this.props.record.gameImage}
                           fallbackSrc={this.props.record.imagePlaceHolderUrl}
                           className={CyClass('cy-tipping-history-game-image')}/>
                </TippingHistoryRecordStartSectionBox>
            );
        }
    }
);